window.SEOFieldsManagerRatingsRenderer = class SEOFieldsManagerRatingsRenderer {
  constructor(ratings, options) {
    this.render = this.render.bind(this);
    this.titleElement = this.titleElement.bind(this);
    this.listElement = this.listElement.bind(this);
    this.ratings = ratings;
    this.options = {
      ...options,
    };
    this.el = jQuery(`<div class='rating-category ${this.options.className}'></div>`);
  }

  render() {
    if (this.options.title != null && this.ratings.length) {
      this.el.append(this.titleElement());
    }
    this.el.append(this.listElement());

    return this;
  }

  // HELPER FUNCTIONS

  titleElement() {
    let text = this.options.title;
    if (this.options.count != null) {
      text = `${text} (${this.ratings.length})`;
    }

    return jQuery(`<div class='category-header'> \
<div class='admin-label-text'>${text}</div> \
</div>`);
  }

  listElement() {
    const list = jQuery("<ul class='assessment-results seo-results'></ul>");

    this.ratings.forEach((rating) =>
      list.append(
        jQuery(`\
<li class='score'> \
<span class='score-icon ${this.options.className}'></span> \
<span class='score-text'>${rating.text}</span> \
</li>\
`),
      ),
    );

    return list;
  }
};
